<template>
  <div class="wrap">
    <!-- <div class="ccod_join">
      <h2>新闻动态</h2>
    </div> -->
      <div class="content">
        <!-- <h1 class="title">{{title}}</h1>
        <div class="text_">
          <span>{{time}}</span> <span>{{num}}</span>次阅读
        </div>
        <div class="contentNews" style="margin-bottom: 80px;text-align:left;" v-html="content"></div> -->
        <!-- <div style="display: block;height: auto;"  v-for="(item ,index) in imgArray" :key="index"> -->
          <img  v-for="(item ,index) in imgArray" :key="index" :src="item" style="width: 100%;z-index:99;background-color:#fff;" />
        <!-- </div> -->
      </div>
      <i class="el-icon-close" @click="back()" style="font-size:60px;position:fixed;top:100px;right:40px;z-index:99;"></i> 
  </div>
</template>

<script>

    import axios from 'axios'
    import qs from 'qs';
export default {
    data(){
        return{
          content:'',
          title:'',
          time:'',
          num:'',
          imgArray:[],
          newsArry: [
        {
          id: "1",
          typeImg: require("../assets/img/new_thumb1.jpg"),
          title: "喜迎二十大",
          description: "",
          releaseDate: "2023/1/13",
          imgs: [require("../assets/img/news1_1.jpg")],
        },
        {
          id: "2",
          typeImg: require("../assets/img/new_thumb2.jpg"),
          title: "青牛荣获“专精特新”中小企业及“小巨人”企业资质",
          description: "",
          releaseDate: "2022/8/20",
          imgs: [require("../assets/img/news2_1.jpg"),require("../assets/img/news2_2.jpg")],
        },
        {
          id: "3",
          typeImg: require("../assets/img/new_thumb3.jpg"),
          title: "澄清说明",
          description: "",
          releaseDate: "2022/3/6",
          imgs: [require("../assets/img/statement.jpg")],
        },
        {
          id: "4",
          typeImg: require("../assets/img/new_thumb4.jpg"),
          title: "青牛荣获中国移动2021年度两项大奖",
          description: "",
          releaseDate: "2021/11/5",
          imgs: [require("../assets/img/news4_1.jpg"),require("../assets/img/news4_2.jpg")],
        },
        {
          id: "5",
          typeImg: require("../assets/img/new_thumb5.jpg"),
          title: "区长调研强调：继续深化合作 携手共进",
          description: "",
          releaseDate: "2021/8/11",
          imgs: [require("../assets/img/news5_1.jpg")],
        },
        {
          id: "6",
          typeImg: require("../assets/img/new_thumb6.jpg"),
          title: "智慧随心 联络自如，青牛参展2020中国移动全球合作伙伴大会",
          description: "",
          releaseDate: "2020/11/18",
          imgs: [require("../assets/img/news6_1.jpg"),require("../assets/img/news6_2.jpg")],
        },
      ],
        }
    },
    methods:{
      back(){
        this.$router.back()
      },
      detail(){
        let id = this.$route.params.c_id
        this.imgArray = this.newsArry.filter(item => item.id == id)[0].imgs;
        // let arr =data[0].imgs;
        // let imgArray =[];
        // arr.forEach(element => {
          // var url = "../assets/img/"+element
          // imgArray.push(url);
        // });
        // this.imgArray = imgArray;
        // console.log(this.imgArray)
        // let that = this;
        // // axios.post('http://60.205.136.57:8089/jeecmsext/help/query',qs.stringify({
        // //   contentId:this.$route.params.c_id
        // // }))
        // axios.get('http://10.130.24.30:8090/news/queryNews',{params:{
        //    contentId:this.$route.params.c_id
        // }})
        // .then(function(res){
        //   //console.log(res);
        //   if(res.data.code==0){
        //     that.content = res.data.obj.txt
        //     that.title = res.data.obj.title
        //     that.time = that.longTimeToDateNoMillisecond(res.data.obj.releaseDate)
        //    // that.num = res.data.obj.views
        //     that.num = parseInt(10 + (Math.random()*100))
        //   }else{

        //   }
        // }).catch(function(error){
        //   console.log(error);
        // })
      },
      longTimeToDateNoMillisecond(longTime){
       // let Time = longTime.replace(new RegExp(/-/g), "/");
      //  console.log(Time)
        let time = longTime.substr(0,longTime.search("T"))
        console.log(time)
        return time;
        var day = new Date(longTime); //将毫秒转化为当前日期
        var year = day.getFullYear();
        var month = day.getMonth()+1;
        var date = day.getDate();
        var hour = day.getHours();
        var minute = day.getMinutes()
        if(month<10){
          month = "0"+month;
        }
        if(date<10){
          date = "0"+date;
        };
        if(hour<10){
          hour = "0"+hour;
        };
        if(minute<10){
          minute = "0"+minute;
        };
        var newDay = year+"-"+month+"-"+date
        return newDay;
      },
    },
  mounted (){
    //console.log(this.$route.params.c_id)
    this.detail()
  },
}
</script>

<style scoped>
  .ccod_join{
    background: url('../assets/img/news.png') no-repeat center;
    width: 100%;
    height: 560px;
    /* background-size: cover; */
    cursor: pointer;
    overflow: hidden;
  }
  .ccod_join h2{
    color: #ffffff;
    font-size: 50px;
    margin-top: 240px;
    font-weight: 500;
  }

  .content{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .title{
    font-size: 36px;
    margin: 40px 0;
    text-align: left;
  }
  .text_{
    font-size: 18px;
    text-align: left;
    margin-bottom: 40px;
  }
</style>





// WEBPACK FOOTER //
// src/components/NewDetail.vue